import React, { memo, useEffect, useState } from "react";

import DocViewer, { DocViewerRenderers } from "react-doc-viewer";

const PdfRender = ({ file }) => {
  const [path, setPath] = useState(null);

  useEffect(() => {
    console.log(file);
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = function () {
        const base64data = reader.result;
        setPath(base64data);
      };
    }
  }, [file]);

  return (
    path && (
      <DocViewer
        pluginRenderers={DocViewerRenderers}
        documents={[
          {
            uri: path,
            fileType: file.type,
          },
        ]}
        config={{
          header: {
            disableHeader: true,
            disableFileName: false,
            retainURLParams: false,
          },
        }}
      />
    )
  );
};

export default memo(PdfRender);
